import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

import { ChartCard } from "./ChartCard";
import { colorForIndex, formatCount } from "./chartPalette";
import styles from "./DonutChartCard.module.css";

export const DonutChartCard = ({ title, data = [], isLoading, dataKey = "count", valueFormatter = formatCount }) => {
  const total = data.reduce((sum, item) => sum + (item[dataKey] ?? 0), 0);

  return (
    <ChartCard title={title} isLoading={isLoading} isEmpty={!isLoading && total === 0}>
      <div className={styles.layout}>
        <ResponsiveContainer width={130} height={130}>
          <PieChart>
            <Pie data={data} dataKey={dataKey} nameKey="label" innerRadius={38} outerRadius={62} paddingAngle={2}>
              {data.map((entry, index) => (
                <Cell key={entry.label} fill={colorForIndex(index)} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => valueFormatter(value)} />
          </PieChart>
        </ResponsiveContainer>
        <ul className={styles.legend}>
          {data.map((entry, index) => (
            <li key={entry.label} className={styles.legendItem}>
              <span className={styles.swatch} style={{ backgroundColor: colorForIndex(index) }} />
              <span className={styles.legendLabel} title={entry.label}>
                {entry.label}
              </span>
              <span className={styles.legendValue}>
                {valueFormatter(entry[dataKey])}
                {total > 0 && ` · ${Math.round((entry[dataKey] / total) * 100)}%`}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </ChartCard>
  );
};
